export default __webpack_public_path__ + "static/media/fr.21f30ccb.svg";